module.exports = __webpack_public_path__ + "static/media/8.7e7bf9fe.jpg";